///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/report-service-categories.collection.ts"/>
///<reference path="../collections/report-services.collection.ts"/>
///<reference path="../collection-population-strategies/service-to-category.strategy.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>



module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportServicesWithCategories extends DataTemplateBase implements IDataTemplate {

        protected serviceCategories: ReportServiceCategoriesCollection;
        protected services: ReportServicesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.serviceCategories;
        }

        get totalSelectedCount(): number {
            return this.services.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], {criteria}) {
            super(model, properties, criteria);

            this.serviceCategories = new ReportServiceCategoriesCollection(this.model[properties[0]], [], {
                criteria
            });

            this.services = new ReportServicesCollection(this.model[properties[1]], [], {
                criteria
            });

            this.services.setParentCollection(this.serviceCategories, ServiceToCategoryStrategy);

            this.tips = [
                'TIP_NOT_SELECTING_SERVICE_CATEGORY'
            ];
            this.title = 'SERVICES';
            this.allSelectedLabel = 'LABEL_ALL_SERVICES';
            this.totalSelectedMessage = 'LABEL_TOTAL_SERVICES_SELECTED';
            this.filters = [
                new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_SERVICES'})
            ];
            this.services.addFilters(...this.filters as IInteractiveFilter[]);
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.services.setWatchers(scope);
        }
    }
}
